import { capitalize, Paper, Typography } from "@mui/material";
import { useT } from "../../i18n";
import Layout from "../../components/Layout";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";
import React from "react";
import Guard from "../../components/Guard";
import TaetigkeitsberichtDataTableFreigabe from "../../components/taetigkeitsberichte/TaetigkeitsberichtDataTableFreigabe";

function TaetigkeitsberichtFreigabe() {
  const { t } = useT("taetigkeitsbericht");
  const limit = parseInt(
    localStorage.getItem("taetigkeitsberichteLimit") ?? "25",
    10
  );
  return (
    <Layout title={capitalize(t("activity-reports"))} showTitleInNav={false}>
      <Guard
        permission={"taetigkeitsbericht:list"}
        fallback={<ErrorAlert error={notPermitted()} />}
      >
        <Paper
          elevation={1}
          sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
        >
          <Typography variant="h5">
            {capitalize(t("activity-reports"))}
          </Typography>
          <TaetigkeitsberichtDataTableFreigabe limit={limit} />
        </Paper>
      </Guard>
    </Layout>
  );
}

export default TaetigkeitsberichtFreigabe;
